import _ from "lodash";
import { useState } from "react";
import {
  Box,
  Divider,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { EditRounded, AddRounded } from "@mui/icons-material";
import axios from "axios";
import { useSnackbar } from "notistack";
import { withPather } from "react-pather";
import InfoChips from "./InfoChips";
import { TagChip, TagModal, TagsSelectModal } from "../tags";

const ConversionChips = ({
  pather,
  conversion,
  setConversion = null,
  size = "medium",
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [openTagModal, setOpenTagModal] = useState(false);
  const [openEditTagsModal, setOpenEditTagsModal] = useState(false);

  const conversionTagCodes = conversion.tags.map((tag) => tag.code);

  const createConversionTag = (name, color) => {
    // Create and add tag to Conversion.
    setOpenTagModal(false);
    setLoading(true);
    axios
      .post(
        pather.reverse(pather.back.Conversion.convTag, {
          code: conversion.code,
        }),
        {
          name,
          color,
        }
      )
      .then((response) => {
        const conversion = response?.data?.conversion;
        if (conversion?.code) setConversion(conversion);
      })
      .catch((error) => {
        console.log(error);
        const status = error?.response?.data?.status;
        if (status) enqueueSnackbar(status, { variant: "error" });
        else
          enqueueSnackbar("Error occurred during tag creation", {
            variant: "error",
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const changeTags = (selectedTagCodes) => {
    setOpenEditTagsModal(false);

    if (_.isEqual(selectedTagCodes, conversionTagCodes)) return;

    setLoading(true);

    axios
      .put(
        pather.reverse(pather.back.Conversion.convTags, {
          code: conversion.code,
        }),
        { tags: selectedTagCodes }
      )
      .then((response) => {
        const conversion = response?.data?.conversion;
        if (conversion?.code) setConversion(conversion);
      })
      .catch((error) => {
        console.log(error);
        const status = error?.response?.data?.status;
        if (status) enqueueSnackbar(status, { variant: "error" });
        else
          enqueueSnackbar("Error occurred during tags editing", {
            variant: "error",
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box>
      {setConversion && (
        <Box className="h3-style" sx={{ mb: 1.5 }}>
          Tags:
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <InfoChips size={size} conversion={conversion} />
        {conversion.tags && conversion.tags.length > 0 && (
          <>
            <Divider orientation="vertical" flexItem />
            {conversion.tags.map((tag) => {
              return (
                <TagChip
                  key={tag.id}
                  label={tag.name}
                  color={tag.color}
                  size={size}
                />
              );
            })}
          </>
        )}
        {loading ? (
          <CircularProgress size={28} />
        ) : (
          <>
            {setConversion && (
              <Box sx={{ display: "flex" }}>
                <Tooltip title="Edit tags" arrow>
                  <IconButton onClick={() => setOpenEditTagsModal(true)}>
                    <EditRounded />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Add new tag" arrow>
                  <IconButton onClick={() => setOpenTagModal(true)}>
                    <AddRounded />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </>
        )}
        {openTagModal && (
          <TagModal
            open={openTagModal}
            setOpen={setOpenTagModal}
            title="Tag Creation"
            confirm={createConversionTag}
          />
        )}
        {openEditTagsModal && (
          <TagsSelectModal
            open={openEditTagsModal}
            setOpen={setOpenEditTagsModal}
            pickedTagCodes={conversionTagCodes}
            title="Edit Tags"
            confirm={changeTags}
          />
        )}
      </Box>
    </Box>
  );
};

export default withPather()(ConversionChips);